<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>Call Center Settings</h5>
                <div>
                    <Button label="Dashboard" class="p-button-sm p-mr-2" @click="goToDashboard" icon="pi pi-th-large" />
                    <Button label="Previous" class="p-button-sm p-mr-1" @click="goToPrevious"
                        icon="pi pi-chevron-left" />
                    <Button label="Next" icon="pi pi-chevron-right" @click="goToNext" class="p-button-sm"
                        iconPos="right" /> 
                </div>
            </div>
            <div class="card p-mt-2">
                <!-- <div>
                    <span class="subtext p-mt-2 p-text-capitalize">
                        <h6>Admin Name : {{ this.localAdminName ? this.localAdminName : '-' }} </h6>
                    </span>
                </div> -->
                <DataTable :value="callcentersettings" :lazy="true" :paginator="true" :rows="30"
                    :totalRecords="totalRecords" :loading="loading" @page="onPage($event)" class="p-datatable-users"
                    dataKey="mbz1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <Toolbar>
                        <template v-slot:left>
                            <!-- <h5 class="p-m-0">Roles Of Vision Created Group</h5> -->
                            <h6>Admin Name : {{ this.localAdminName ? this.localAdminName : '-' }} </h6>
                        </template>
                        <template v-slot:right>
                            <Button label="Add Call Center" icon="pi pi-plus" @click="toAddCallCenter" />
                        </template>
                    </Toolbar>
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column headerStyle="width: 2%" class="align-center"></Column>
                    <Column field="id" header="Sr." headerStyle="width: 10%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column header="Call List" field="ca2" class="p-text-capitalize" headerStyle="width: 15%">
                    </Column>
                    <Column header="Virtual Number" class="p-text-capitalize" headerStyle="width: 35%">
                        <template #body="{ data }">
                            <MultiSelect v-model="data.ca4" :options="computeddidsNumbersList(data)" optionLabel="label"
                                placeholder="Select Virtual Numbers" object="false" style="width: 70%;" :filter="true"
                                class="multiselect-custom" appendTo="body" />
                            <button style="margin-left: 8px;" class="p-button p-button-success"
                                @click="assignVirtualNumberToCallCenter(data)">Allow</button>
                        </template>
                    </Column>
                    <Column header="Status" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <InputSwitch v-model="data.ca10" @click="confirmCallPermissions(data)" />
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <!-- <div class="p-d-flex p-ai-center p-mb-2">
                                <Button icon="pi pi-pencil" style="width:60%;"
                                    class="p-button-success p-mr-2" @click="submitPermissionsModalOpen(data)">
                                    <i class="pi pi-pencil"> Add DID</i></Button>
                            </div> -->
                            <div class="p-d-flex p-ai-center">
                                <Button icon="pi pi-cog" style="width:60%;" class=" p-mr-2"
                                    @click="submitPermissionsModalOpen(data)"><i class="pi pi-cog"> Settings</i>
                                </Button>
                            </div>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>

    <!-- Add Call center -->
    <Dialog v-model:visible="isAddCall" :style="{ width: '800px' }" :modal="true" class="p-fluid"
        header="Add Call List Number">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="callNumber">
                            Add Call List Number
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <Dropdown id="callNumber" class="p-text-capitalize" v-model="callNumber"
                            :options="callListNumber" optionLabel="value" object="true" required="true"
                            :class="{ 'p-invalid': isSubmitted && !roleName }" placeholder="Select call list number"
                            emptyMessage="No Records" appendTo="body" />
                        <small class="p-invalid p-error" v-if="v$.callNumber?.$error">{{
                            v$.callNumber?.$errors[0].$message
                            }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="virtualNumber">
                            Virtual Number
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <MultiSelect v-model="virtualNumber" :options="didsNumbersList" optionLabel="label"
                            placeholder="Select Virtual Numbers" required="true" object="false" :filter="true"
                            class="multiselect-custom" appendTo="body" />
                        <small class="p-invalid p-error" v-if="v$.virtualNumber?.$error">{{
                            v$.virtualNumber?.$errors[0].$message
                            }}</small>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="addCallListWithVirtualNumberToCallCenter"
                style="width: 90px;"></Button>
            <!-- <Button v-show="showLoaderAddBtn" icon="pi pi-spin pi-spinner indigo-color" class="p-button-text p-ml-auto"
                style="width: 90px"></Button> -->
        </template>
    </Dialog>
    <!-- Add Call center     ends here -->

    <!-- call center permissions start here -->
    <Dialog v-model:visible="userCriticalPermissionsStatus" :style="{ width: '800px' }"
        header="Communication Permissions" :modal="true" class="p-fluid">

        <DataTable :value="criticalPermissionsList" :lazy="true" :paginator="false" :loading="loading"
            class="p-datatable-users" data-key="value" :rowHover="true">
            <template #empty> No data found. </template>
            <template #loading> Loading data. Please wait... </template>
            <Column headerStyle="width: 2%" class="align-center"></Column>
            <Column header="Sr." headerStyle="width: 5%">
                <template #body="{ index }">
                    {{ ++index }}
                </template>
            </Column>
            <Column header="Permissions" headerStyle="width: 40%">
                <template #body="{ data }">
                    <div>{{ data.label }}</div>
                </template>
            </Column>
            <Column header="Status" headerStyle="width: 10%">
                <template #body="{ data }">
                    <InputSwitch v-model="data.status" />
                </template>
            </Column>
        </DataTable>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="updateCumminicationPermissionStatus(rowData)"
                style="width: 90px;"></Button>
        </template>
    </Dialog>
    <!-- call center permissions end here -->
    <!-- confirmation modal start here -->
    <ConfirmDialog group="positioned" @hide="onDialogHide"></ConfirmDialog>
    <!-- confirmation modal end here -->
</template>

<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import { useConfirm } from "primevue/useconfirm";
import router from '@/router';
import { useRoute } from 'vue-router';
import { required, helpers } from '@vuelidate/validators';

export default {
    data() {
        return {
            confirm: useConfirm(),
            // callcentersettings: [],
            v$: useValidate(),
            isAddReport: false,
            isAddCall: false,
            isSubmitted: false,
            showLoader: false,
            loading: false,
            page_no: 0,
            totalRecords: 0,
            isEditUserRole: false,
            showLoaderAddBtn: false,
            rowId: '',
            reportreason: '',
            countries: [],
            city: '',
            country: '',
            pincode: '',
            cityList: [],
            adminstatus: { label: 'Active', value: 1 },
            isFilter: false,
            areaFilter: '',
            areaFilterList: [],
            userCriticalPermissionsStatus: false,
            criticalPermissionsList: [
                { value: '1', label: 'Allow SMS', key: 'ca6', status: false },
                { value: '2', label: 'Allow Push notification', key: 'ca7', status: true },
                { value: '3', label: 'Allow RCS', key: 'ca8', status: true },
                { value: '4', label: 'Allow Email', key: 'ca9', status: false },
            ],
            didNumbers: [],
            callsettingsstatus: false,
            selectedRow: {},
            localAdminName: '',
            callcentersettings: [],
            selectedDids: [],
            didsNumbersList: [],
            callListNumber: [],
            callNumber: '',
            virtualNumber: '',
            routeParam: '',
            callid: '',
        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    async mounted() {
        this.loading = true;
        const route = useRoute();
        this.routeParam = route.params.adminSubId;
        this.localAdminName = localStorage.localAdminName;
        this.getCallCenterSetting({ maa1: this.routeParam });
        this.getVirtualNumberByClientId({ maa1: this.routeParam });
    },
    computed: {
        computeddidsNumbersList() {
            return (data) => {
                if (!data || !data.selected) return [...this.didsNumbersList];
                const unselected = this.didsNumbersList.filter(
                    item => !data.selected.some(selected => selected.value === item.value)
                );
            return [...data.selected, ...unselected];
        };
        }
    },
    validations() {
        return {
            callNumber: { required: helpers.withMessage('select call number', required) },
            virtualNumber: { required: helpers.withMessage('Select virtual number', required) },
        };
    },

    methods: {
        getVirtualNumberByClientId(e) {
            this.ApiService.getVirtualNumberByClientId(e).then((items) => {
                if (items.status === 200) {
                    this.didsNumbersList = items.data;
                }
            })
        },
        getCallLsit(e) {
            this.ApiService.getCallLsit(e).then((items) => {
                if (items.status === 200) {
                    this.callListNumber = items.data;
                }
            })
        },
        getCallCenterSetting(e) {
            e.page_no = this.page_no;
            e.maa1 = this.routeParam;
            this.ApiService.getCallCenterSetting(e).then((items) => {
                if (items.status === 200) {
                    this.callcentersettings = items.data;
                    this.callcentersettings = this.callcentersettings.map(item => ({...item, selected: [...(item.ca4 || [])] }));
                    this.callcentersettings = this.callcentersettings.map(item => {
                        if (item.ca10 == 1) {
                            item.ca10 = true;
                        } else {
                            item.ca10 = false;
                        }
                        return item;
                    });
                    this.totalRecords = items.count;
                    this.isFilter = false;
                } else {
                    this.callcentersettings = [];
                }
                this.loading = false;
            });
        },
        assignVirtualNumberToCallCenter(e) {
            let formData = new FormData();
            formData.append('maa1', this.routeParam);
            formData.append('ca1', e.ca1);
            formData.append('ca2', e.ca2);
            formData.append('ca5', e.ca5);

            let selectedObj = {};
            let selectedValues = new Set(); // Track selected values

            e.ca4.forEach(item => {
                if (item.value !== null && item.label !== null) {
                    selectedObj[item.value] = item.label;
                    selectedValues.add(item.value); // Add to set for unselected check
                }
            });

            formData.append('selected', JSON.stringify(selectedObj));

            // Determine unselected numbers from the full list (didsNumbersList)
            let unselectedObj = {};
            [...e.selected, ...this.didsNumbersList].forEach(item => {
                if (!e.ca4.some(caItem => caItem.value === item.value)) {
                    unselectedObj[item.value] = item.label;
                }
            });

            formData.append('unselected', JSON.stringify(unselectedObj));

            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.assignVirtualNumberToCallCenter(formData)
                    .then((response) => {
                        this.showLoaderAddBtn = false;
                        if (response.status == 200) {
                            this.$toast.add({ severity: 'success', summary: 'Successful', detail: response.message, life: 3000 });
                            this.userCriticalPermissionsStatus = false; // Close modal
                            this.getCallCenterSetting({ page_no: this.page_no });
                            this.getVirtualNumberByClientId({ maa1: this.routeParam });
                        } else {
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: response.message, life: 3000 });
                        }
                    })
                    .catch(error => {
                        this.showLoaderAddBtn = false;
                        console.error("API Error:", error);
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong!', life: 3000 });
                    });
            }
        },
        addCallListWithVirtualNumberToCallCenter() {
            const virtualNumberId = Array.isArray(this.virtualNumber)
                ? this.virtualNumber.map(({ label, value }) => ({ label, value }))
                : [];

            let formData = new FormData();
            formData.append('maa1', this.routeParam);
            formData.append('ca5', this.callNumber.lable);
            formData.append('ca2', this.callNumber.value);
            formData.append('selected', JSON.stringify(virtualNumberId));

            this.submitted = true;
            this.errormsg = '';
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.addCallListWithVirtualNumberToCallCenter(formData)
                    .then((response) => {
                        this.showLoaderAddBtn = false;
                        if (response.status == 200) {
                            this.$toast.add({ severity: 'success', summary: 'Successful', detail: response.message, life: 3000 });
                            this.isAddCall = false; // Close modal
                            this.getCallCenterSetting({ page_no: this.page_no });
                            this.getVirtualNumberByClientId({ maa1: this.routeParam });
                        } else {
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: response.message, life: 3000 });
                        }
                    })
                    .catch(error => {
                        this.showLoaderAddBtn = false;
                        console.error("API Error:", error);
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong!', life: 3000 });
                    });
            }
        },

        submitPermissionsModalOpen(data) {
            this.userCriticalPermissionsStatus = true;
            this.isEditUserRole = true;
            this.rowId = data.ca1;
            this.callid = data.ca2;
            this.criticalPermissionsList[0].status = data.ca6;
            this.criticalPermissionsList[1].status = data.ca7;
            this.criticalPermissionsList[2].status = data.ca8;
            this.criticalPermissionsList[3].status = data.ca9;
        },
        rowPermissionsStatus(data) {
            let formData = new FormData();
            formData.append('maa1', this.routeParam);
            formData.append('ca1', data.ca1);
            formData.append('ca2', data.ca2);
            formData.append('ca10', data.ca10 == true ? 1 : 0);
            this.submitted = true;
            this.errormsg = '';
            this.showLoaderAddBtn = true;
            this.ApiService.updateCallPermissionStatus(formData)
                .then((response) => {
                    this.showLoaderAddBtn = false;
                    if (response.status == 200) {
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: response.message, life: 3000 });
                        this.userCriticalPermissionsStatus = false; // Close modal
                        this.getCallCenterSetting({ page_no: this.page_no });
                    } else {
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: response.message, life: 3000 });
                    }
                })
                .catch(error => {
                    this.showLoaderAddBtn = false;
                    console.error("API Error:", error);
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong!', life: 3000 });
                });

        },
        updateCumminicationPermissionStatus() {
            let formData = new FormData();
            formData.append('maa1', this.routeParam);
            formData.append('ca1', this.rowId);
            formData.append('ca2', this.callid);
            formData.append('ca6', this.criticalPermissionsList[0].status == true ? 1 : 0);
            formData.append('ca7', this.criticalPermissionsList[1].status == true ? 1 : 0);
            formData.append('ca8', this.criticalPermissionsList[2].status == true ? 1 : 0);
            formData.append('ca9', this.criticalPermissionsList[3].status == true ? 1 : 0);

            this.submitted = true;
            this.errormsg = '';

            this.showLoaderAddBtn = true;
            this.ApiService.updateCumminicationPermissionStatus(formData)
                .then((response) => {
                    this.showLoaderAddBtn = false;
                    if (response.status == 200) {
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: response.message, life: 3000 });
                        this.userCriticalPermissionsStatus = false; // Close modal
                        this.getCallCenterSetting({ page_no: this.page_no });
                    } else {
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: response.message, life: 3000 });
                    }
                })
                .catch(error => {
                    this.showLoaderAddBtn = false;
                    console.error("API Error:", error);
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong!', life: 3000 });
                });

        },

        onPage(event) {
            this.loading = true;
            this.page_no = event.page;
            this.getCallCenterSetting({ page_no: event.page });
        },
        reSetFilteredData() {
            this.getCallCenterSetting({ page_no: this.page_no });
            this.isFilter = false;
            this.areaFilter = '';
            this.adminstatus = '';
            // this.showFillFilter = false;
        },
        confirmCallPermissions(data) {
            this.selectedRow = data
            this.$confirm.require({
                group: 'positioned',
                message: 'Are you sure?',
                header: 'Confirm call permissions change',
                icon: 'pi pi-exclamation-triangle',
                position: 'top',
                rejectProps: {
                    label: 'Cancel',
                    severity: 'secondary',
                    outlined: true
                },
                acceptProps: {
                    label: 'Confirm',
                    severity: 'danger'
                },
                accept: () => {
                    this.rowPermissionsStatus(data)
                    this.selectedRow.ca10 = !this.selectedRow.ca10
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: 'Cancelled', detail: 'Call permissions cancelled', life: 3000 });
                },
            });
        },
        onDialogHide() {
            this.selectedRow.ca10 = !this.selectedRow.ca10
        },
        addSubmenu() {
            // maximum 5 field sould add
            if (this.didNumbers.length >= 5) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Maximum 5 DID numbers sould add', life: 3000 });
                return
            }
            this.didNumbers.push("");
        },
        goToDashboard() {
            router.push({
                name: "admindashboard",
                params: { adminId: this.routeParam },
            });
        },
        goToPrevious() {
            router.push({
                name: "AppVersionSetting",
                params: { adminSubId: this.routeParam },
            });
        },
        goToNext() {
            router.push({
                name: "configSetting",
                params: { adminSubId: this.routeParam },
            });
        },
        toAddCallCenter() {
            this.isAddCall = true;
            this.virtualNumber = [];
            this.callListNumber = [];
            this.getCallLsit();
            this.v$.$reset();
            this.callNumber = ''
            this.isSubmitted = false;
        },
    }
};
</script>